import './AboutUsStyles.css'

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        TourTango is the perfect travel destination. we create unforgettable
        vacations in enticing destinations. Our travel experts love finding the
        perfect spot for your next adventure. TourTango has the best travel advice
        for beaches, mountains, cities, and landmarks. We strive to exceed your
        travel expectations with our comprehensive knowledge of the world's most
        sought-after places. Discover the world's beauty with TourTango.
      </p>

      <h1>Our Mission</h1>
      <p>
        Our mission is to touch the horizon where our capabilities may
        successfully meet with the requirements of our clients, that too with
        ultimate transparency and cost-effectiveness.
      </p>

      <h1>Our Vision</h1>
      <p>
        To sow the seeds of par-excellence services with customer centric
        approach and reap the trust of worldwide clients.
      </p>
    </div>
  )
}
export default AboutUs
